import Enum from "@/enums/Enum";


export default class BaseEnum {
    static values = [] as Enum[]

    static getEnum(value: string|number){
        for(const num of this.values){
            if(num.value === value){
                return num
            }
        }
    }

    static getName(value: string|number){
        return this.getEnum(value)?.name
    }
}
/*

BaseEnum.ts:9 num.value=| |
 */